"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProductList = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _utils = require("../utils");
/* istanbul ignore file @preserve --api */

const createProductList = async ({
  client,
  customerId,
  description,
  name,
  productCodes,
  type
}) => {
  const {
    data: list
  } = await (0, _globalApiClientReact.createCustomerProductListTypeProductList)(client, customerId, type, {
    items: (0, _utils.mapListToApiObject)(productCodes),
    description,
    name
  });
  const {
    productListId
  } = list;
  if (!productListId) {
    return null;
  }
  return (0, _utils.mapGlobalApiProductListToList)({
    list: {
      ...list,
      productListId
    },
    type
  });
};
exports.createProductList = createProductList;
//# sourceMappingURL=createProductList.js.map